import React from 'react'
import { useEffect } from 'react';
import { exportLocomotive, getAllLocomotive } from '../../Services/LocomotiveServices'
import Listing from '../../Components/Listing/Listing'
import { resetLocomotiveFilters, setLocomotiveFilters } from '../../redux/features/filterSlice'
import { useSelector, useDispatch } from 'react-redux';

import roleManager from '../../Components/roles'

const LocomotiveListing = () => {
    const dispatch = useDispatch();
    
    const storedFilters = JSON.parse(localStorage.getItem('locomotiveFilters')) || {};
    const value = useSelector((state) => state.filters);

    useEffect(() => {
        dispatch(setLocomotiveFilters(storedFilters));
    }, [dispatch]);

    useEffect(() => {
        localStorage.setItem('locomotiveFilters', JSON.stringify(value.filters));
    }, [value.filters]);
    return (
        <Listing
            path={'/LocomotiveEdit'}
            ListingApi={getAllLocomotive}
            name={'Locomotive'}
            exportListing={exportLocomotive}
            setFilter={setLocomotiveFilters}
            resetFilter={resetLocomotiveFilters}
            state={value.filters}
            showAddButton={roleManager("locomotive", "lookupEdit", "Addlocmotive") ? true : false}
            showDeleteButton={true}

        />
    )
}

export default LocomotiveListing